/* ======================================
   IGLOO THEME.JS (FIXED + SINGLE INIT)
   Includes:
   1) Preloader (safe init)
   2) Snow overlay (canvas, lightweight)
   3) Three.js spinning wire dome (safe init)
   Notes:
   - Removes duplicate dome init blocks that were cancelling each other
   - Safe for Shopify Theme Editor section reloads
====================================== */

/* ======================================
   1) IGLOO PRELOADER (safe init)
====================================== */
(function () {
  if (window.__IGLOO_PRELOADER_INIT__) return;
  window.__IGLOO_PRELOADER_INIT__ = true;

  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  function boot() {
    var el = document.getElementById('igloo-preloader');
    if (!el) return;

    var bar = el.querySelector('.igloo-preloader__bar span');
    var pctEl = document.getElementById('igloo-preloader-pct');

    // Allow manual hide if needed
    window.__IGLOO_HIDE_PRELOADER__ = function () {
      el.classList.add('is-hidden');
    };

    var target = 0;
    var shown = true;
    var last = performance.now();

    function setProgress(p) {
      p = clamp(p, 0, 100);
      if (bar) bar.style.width = p + '%';
      if (pctEl) pctEl.textContent = Math.round(p) + '%';
    }

    function tick(now) {
      var dt = Math.min(100, now - last);
      last = now;

      if (shown) {
        var cur = parseFloat((bar && bar.style.width) ? bar.style.width : '0') || 0;
        var next = cur + (target - cur) * (1 - Math.pow(0.001, dt));
        setProgress(next);
        requestAnimationFrame(tick);
      }
    }

    // Phase 1: fast to ~70
    target = 70;
    requestAnimationFrame(tick);

    // Phase 2: creep to ~92
    var creep = setInterval(function () {
      if (!shown) { clearInterval(creep); return; }
      target = clamp(target + 1.5, 70, 92);
    }, 420);

    function finish() {
      if (!shown) return;
      shown = false;
      clearInterval(creep);
      setProgress(100);
      setTimeout(function () {
        el.classList.add('is-hidden');
      }, 220);
    }

    // Full load
    window.addEventListener('load', finish, { once: true });

    // 3D scene can dispatch this
    window.addEventListener('igloo:ready', finish, { once: true });

    // Theme editor fallback
    setTimeout(function () {
      if (shown && document.readyState === 'complete') finish();
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();


/* =========================================
   2) IGLOO SNOW + 3) SPINNING DOME (ONE INIT)
========================================= */
(function () {
  if (window.__IGLOO_SNOW_DOME_INIT__) return;
  window.__IGLOO_SNOW_DOME_INIT__ = true;

  /* ---------------------------
     SNOW CANVAS
  --------------------------- */
  function initSnow() {
    // If already running, do nothing
    if (window.__IGLOO_SNOW_STATE__ && window.__IGLOO_SNOW_STATE__.running) return;

    var existing = document.getElementById("igloo-snow");
    if (!existing) {
      existing = document.createElement("canvas");
      existing.id = "igloo-snow";
      existing.setAttribute("aria-hidden", "true");

      // Force it on top of canvas/overlay but behind UI (your UI is z-index 10+)
      existing.style.position = "fixed";
      existing.style.inset = "0";
      existing.style.width = "100%";
      existing.style.height = "100%";
      existing.style.pointerEvents = "none";
      existing.style.zIndex = "3";
      existing.style.opacity = "0.9";

      document.body.appendChild(existing);
    }

    var c = existing;
    var ctx = c.getContext("2d", { alpha: true });

    var w = 0, h = 0;
    var raf = null;

    var flakes = [];
    var FLAKE_COUNT = 120;

    function rand(min, max) { return Math.random() * (max - min) + min; }

    function resize() {
      w = c.width = window.innerWidth;
      h = c.height = window.innerHeight;

      // scale flakes with screen size
      FLAKE_COUNT = Math.min(180, Math.max(80, Math.floor((w * h) / 14000)));
    }

    function seed() {
      flakes.length = 0;
      for (var i = 0; i < FLAKE_COUNT; i++) {
        flakes.push({
          x: rand(0, w),
          y: rand(0, h),
          r: rand(0.6, 2.2),
          vy: rand(0.35, 1.45),
          vx: rand(-0.25, 0.25),
          drift: rand(0, Math.PI * 2),
          a: rand(0.12, 0.55)
        });
      }
    }

    function tick() {
      raf = requestAnimationFrame(tick);
      ctx.clearRect(0, 0, w, h);

      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.drift += 0.01;
        f.x += f.vx + Math.sin(f.drift) * 0.15;
        f.y += f.vy;

        if (f.y > h + 10) { f.y = -10; f.x = rand(0, w); }
        if (f.x < -10) f.x = w + 10;
        if (f.x > w + 10) f.x = -10;

        ctx.beginPath();
        ctx.fillStyle = "rgba(255,255,255," + f.a + ")";
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    function onResize() {
      resize();
      seed();
    }

    resize();
    seed();
    tick();

    window.addEventListener("resize", onResize, { passive: true });

    window.__IGLOO_SNOW_STATE__ = {
      running: true,
      raf: raf,
      canvas: c,
      onResize: onResize
    };

    // Cleanup when section unloads (Theme Editor)
    document.addEventListener("shopify:section:unload", function () {
      try {
        if (window.__IGLOO_SNOW_STATE__ && window.__IGLOO_SNOW_STATE__.raf) {
          cancelAnimationFrame(window.__IGLOO_SNOW_STATE__.raf);
        }
      } catch (e) {}

      try { window.removeEventListener("resize", onResize); } catch (e) {}

      try { c.remove(); } catch (e) {}
      window.__IGLOO_SNOW_STATE__ = { running: false };
    });
  }

  /* ---------------------------
     THREE.JS SPINNING DOME
  --------------------------- */
  function initDome() {
  var wrap = document.getElementById("canvas-wrapper");
  if (!wrap) return;

  // Already created renderer? Don't create another.
  if (wrap.__iglooRenderer) return;

  if (!window.THREE) {
    console.warn("[IGLOO] THREE not found. Ensure three.min.js is loaded ONCE in theme.liquid.");
    return;
  }

  var THREE = window.THREE;

  function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t){ return a + (b - a) * t; }
  function smoothstep(t){ t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }

  var hero = wrap.closest('.hero-container');
  var panels = hero ? hero.querySelectorAll('.igloo-panel') : [];

  // Scroll state (5 panels = 5 story beats)
  var scrollTop = 0;
  var scrollMax = 1;
  var activeIdx = 0; // 0..4
  var activeT = 0;

  // Smooth scroll inertia (igloo.inc-style)
  var scrollTarget = 0;
  var scrollSmoothed = 0;
   // 0..1 within panel

  function computeScrollState(){
    if (!hero) return;
    scrollTop = hero.scrollTop || 0;
      scrollTarget = scrollTop;
      if (!scrollSmoothed) scrollSmoothed = scrollTop;

    scrollMax = Math.max(1, (hero.scrollHeight || 1) - (hero.clientHeight || 1));

    // Determine active panel by viewport mid
    var mid = scrollTop + (hero.clientHeight || 1) * 0.5;
    var bestIdx = 0;
    var bestDist = Infinity;

    for (var i=0;i<panels.length;i++){
      var p = panels[i];
      var center = p.offsetTop + p.offsetHeight * 0.5;
      var d = Math.abs(center - mid);
      if (d < bestDist){ bestDist = d; bestIdx = i; }
    }
    activeIdx = clamp(bestIdx, 0, Math.max(0, panels.length-1));

    // progress within active panel
    var cur = panels[activeIdx];
    if (cur){
      var start = cur.offsetTop;
      var end = start + cur.offsetHeight - (hero.clientHeight || 1);
      var denom = Math.max(1, end - start);
      activeT = clamp((scrollTop - start) / denom, 0, 1);
    } else {
      activeT = 0;
    }

    // Expose to CSS HUD
    try {
      hero.setAttribute('data-step', String(activeIdx + 1));
      hero.style.setProperty('--igloo-panel-t', String(activeT));
    } catch(e){}
  }

  if (hero){
    computeScrollState();
    hero.addEventListener('scroll', computeScrollState, { passive:true });
  }

  // Renderer
  var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
  renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
  renderer.setSize(wrap.clientWidth || window.innerWidth, wrap.clientHeight || window.innerHeight);
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.domElement.style.width = "100%";
  renderer.domElement.style.height = "100%";
  renderer.domElement.style.display = "block";

  try { wrap.innerHTML = ""; } catch (e) {}
  wrap.appendChild(renderer.domElement);
  wrap.__iglooRenderer = renderer;

  try { window.dispatchEvent(new Event('igloo:ready')); } catch (e) {}

  // Scene / camera
  var scene = new THREE.Scene();
  scene.background = null;
  scene.fog = new THREE.FogExp2(0xb8c2cf, 0.08);

  var camera = new THREE.PerspectiveCamera(42, (wrap.clientWidth || window.innerWidth) / (wrap.clientHeight || window.innerHeight), 0.01, 200);
  camera.position.set(0, 1.2, 4.4);

  // Lights
  var light1 = new THREE.DirectionalLight(0xffffff, 1.05);
  light1.position.set(2.8, 4.0, 3.5);
  scene.add(light1);

  var light2 = new THREE.AmbientLight(0xffffff, 0.55);
  scene.add(light2);

  // Root group
  var root = new THREE.Group();
  scene.add(root);

  // ===========
  // TERRAIN (Sections 1 + 5)
  // ===========
  var terrainGeo = new THREE.PlaneGeometry(14, 10, 120, 90);
  terrainGeo.rotateX(-Math.PI/2);

  (function displaceTerrain(g){
    var pos = g.attributes.position;
    for (var i=0;i<pos.count;i++){
      var x = pos.getX(i), z = pos.getZ(i);
      // layered sine noise (cheap)
      var h = 0.0;
      h += Math.sin(x * 0.55) * 0.10;
      h += Math.cos(z * 0.45) * 0.08;
      h += Math.sin((x+z) * 0.25) * 0.12;
      // soften edges
      var edge = Math.max(Math.abs(x)/7, Math.abs(z)/5);
      h *= (1.0 - clamp(edge, 0, 1) * 0.65);
      pos.setY(i, h);
    }
    pos.needsUpdate = true;
    g.computeVertexNormals();
  })(terrainGeo);

  var terrainMat = new THREE.MeshStandardMaterial({
    color: 0x9aa5b4,
    roughness: 0.95,
    metalness: 0.0
  });
  var terrain = new THREE.Mesh(terrainGeo, terrainMat);
  terrain.position.set(0, -0.45, 0.2);
  root.add(terrain);

  // ===========
  // IGLOO (Sections 1 + 5)
  // ===========
  var iglooGroup = new THREE.Group();
  iglooGroup.position.set(0, -0.15, 0);
  root.add(iglooGroup);

  var iglooShellGeo = new THREE.SphereGeometry(1.05, 48, 36, 0, Math.PI*2, 0, Math.PI*0.78);
  var iglooShellMat = new THREE.MeshStandardMaterial({
    color: 0x7f8a98,
    roughness: 0.88,
    metalness: 0.0,
    emissive: 0x000000,
    emissiveIntensity: 0.0
  });
  var iglooShell = new THREE.Mesh(iglooShellGeo, iglooShellMat);
  iglooShell.castShadow = false;
  iglooShell.receiveShadow = false;
  iglooGroup.add(iglooShell);

  // base ring
  var baseGeo = new THREE.CylinderGeometry(1.05, 1.05, 0.6, 48, 1, true);
  var baseMat = iglooShellMat;
  var base = new THREE.Mesh(baseGeo, baseMat);
  base.position.y = -0.35;
  iglooGroup.add(base);

  // entrance tunnel
  var tunnelGeo = new THREE.CylinderGeometry(0.35, 0.40, 0.65, 28, 1, true);
  tunnelGeo.rotateZ(Math.PI/2);
  var tunnel = new THREE.Mesh(tunnelGeo, iglooShellMat);
  tunnel.position.set(0.95, -0.28, 0.15);
  iglooGroup.add(tunnel);

  // seam lines (glow-able)
  function makeEdges(mesh){
    var e = new THREE.EdgesGeometry(mesh.geometry, 18);
    var m = new THREE.LineBasicMaterial({ color: 0xeaf4ff, transparent: true, opacity: 0.06 });
    var l = new THREE.LineSegments(e, m);
    l.position.copy(mesh.position);
    l.rotation.copy(mesh.rotation);
    l.scale.copy(mesh.scale);
    return l;
  }
  var seam1 = makeEdges(iglooShell);
  var seam2 = makeEdges(base);
  var seam3 = makeEdges(tunnel);
  iglooGroup.add(seam1); iglooGroup.add(seam2); iglooGroup.add(seam3);

  // ===========
  // CRYSTALS (Sections 2 + 3)
  // ===========
  function buildCrystal(detail, jagged){
    var g = new THREE.IcosahedronGeometry(1.15, detail);
    var pos = g.attributes.position;

    function hash(n){
      var x = Math.sin(n * 127.1) * 43758.5453123;
      return x - Math.floor(x);
    }

    for (var i=0;i<pos.count;i++){
      var x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i);
      var len = Math.sqrt(x*x+y*y+z*z) || 1;
      var nx = x/len, ny = y/len, nz = z/len;
      var r1 = hash(i * 3.11);
      var r2 = hash(i * 7.77 + 19.19);
      var bump = (r1 * 0.45 + r2 * 0.55);
      bump = Math.pow(bump, 1.35);
      var scale = 1.0 + (bump - 0.5) * jagged;
      pos.setXYZ(i, nx * len * scale, ny * len * (scale * 1.05), nz * len * scale);
    }
    pos.needsUpdate = true;
    g.computeVertexNormals();
    return g;
  }

  var crystalMat = new THREE.MeshPhysicalMaterial({
    color: 0xcfe6ff,
    roughness: 0.05,
    metalness: 0.0,
    transmission: 0.92,
    thickness: 1.6,
    ior: 1.35,
    clearcoat: 1.0,
    clearcoatRoughness: 0.10,
    transparent: true,
    opacity: 1.0
  });

  var crystalRaw = new THREE.Mesh(buildCrystal(3, 0.55), crystalMat.clone());
  crystalRaw.position.set(0, 0.05, 0);
  crystalRaw.scale.set(1.0, 1.1, 1.0);
  root.add(crystalRaw);

  var crystalSlab = new THREE.Mesh(buildCrystal(2, 0.25), crystalMat.clone());
  crystalSlab.position.set(0, 0.06, 0);
  crystalSlab.scale.set(1.05, 0.78, 0.85);
  root.add(crystalSlab);

  // Embedded logo plane for Section 3
  function makeLogoTexture(){
    var c = document.createElement('canvas');
    c.width = 256; c.height = 256;
    var ctx = c.getContext('2d');
    ctx.clearRect(0,0,256,256);
    ctx.fillStyle = 'rgba(20,24,30,0.85)';
    ctx.fillRect(46,46,164,164);
    ctx.strokeStyle = 'rgba(255,255,255,0.6)';
    ctx.lineWidth = 6;
    ctx.strokeRect(46,46,164,164);
    ctx.fillStyle = 'rgba(255,255,255,0.92)';
    ctx.font = 'bold 96px ui-monospace, Menlo, Consolas, monospace';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('IP', 128, 132);
    var tex = new THREE.CanvasTexture(c);
    tex.colorSpace = THREE.SRGBColorSpace;
    tex.needsUpdate = true;
    return tex;
  }

  var logoPlaneMat = new THREE.MeshBasicMaterial({ map: makeLogoTexture(), transparent: true, opacity: 0.0 });
  var logoPlane = new THREE.Mesh(new THREE.PlaneGeometry(0.95, 0.95), logoPlaneMat);
  logoPlane.position.set(0.0, 0.05, 0.18);
  root.add(logoPlane);

  // ===========
  // RINGS (Section 4)
  // ===========
  var rings = new THREE.Group();
  root.add(rings);

  function addRing(r, tube, arc, y){
    var g = new THREE.TorusGeometry(r, tube, 18, 90, arc);
    var m = new THREE.MeshBasicMaterial({ color: 0xeaf4ff, transparent: true, opacity: 0.0 });
    var mesh = new THREE.Mesh(g, m);
    mesh.position.y = y;
    mesh.rotation.x = Math.PI/2;
    rings.add(mesh);
    return mesh;
  }

  var ringA = addRing(1.55, 0.035, Math.PI*1.75, 0.0);
  var ringB = addRing(1.15, 0.028, Math.PI*1.55, 0.0);
  var ringC = addRing(0.78, 0.020, Math.PI*1.35, 0.0);


// ===========
// TRANSITION SHARDS (even panels)
// ===========
var transitionGroup = new THREE.Group();
root.add(transitionGroup);

var shardGeo = new THREE.IcosahedronGeometry(0.10, 0);
var shardMat = new THREE.MeshBasicMaterial({ color: 0xeaf4ff, transparent: true, opacity: 0.0 });
var shards = [];
(function initShards(){
  // deterministic-ish placement
  function hash(n){
    var x = Math.sin(n * 127.1) * 43758.5453123;
    return x - Math.floor(x);
  }
  var count = 140;
  for (var i=0;i<count;i++){
    var m = shardMat.clone();
    m.opacity = 0.0;
    var s = new THREE.Mesh(shardGeo, m);
    // random direction on sphere
    var u = hash(i*1.3);
    var v = hash(i*2.1+9.7);
    var theta = u * Math.PI * 2;
    var phi = Math.acos(2*v - 1);
    var r = 1.05 + hash(i*3.9+2.2) * 0.45;

    s.userData.base = {
      x: Math.sin(phi)*Math.cos(theta) * r,
      y: (Math.cos(phi) * r) * 0.85,
      z: Math.sin(phi)*Math.sin(theta) * r,
      rx: hash(i*4.1) * Math.PI,
      ry: hash(i*5.2) * Math.PI,
      rz: hash(i*6.3) * Math.PI,
      sp: 0.4 + hash(i*7.4) * 0.9
    };

    s.position.set(s.userData.base.x, s.userData.base.y, s.userData.base.z);
    s.rotation.set(s.userData.base.rx, s.userData.base.ry, s.userData.base.rz);
    transitionGroup.add(s);
    shards.push(s);
  }
})();


// ===========
// TRANSITION FX (igloo.inc-style)
// ===========
// Mist planes + subtle chromatic layers to mimic the "fog/distortion wipe" transition.
var fxGroup = new THREE.Group();
root.add(fxGroup);

var mistGroup = new THREE.Group();
fxGroup.add(mistGroup);

function makeMistPlane(size, opacity){
  var g = new THREE.PlaneGeometry(size, size);
  var m = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: opacity, depthWrite: false });
  var p = new THREE.Mesh(g, m);
  p.renderOrder = 10;
  return p;
}

// Big soft mist sheets around the camera forward axis
var mistA = makeMistPlane(10, 0.0);
var mistB = makeMistPlane(12, 0.0);
var mistC = makeMistPlane(14, 0.0);

mistA.position.set(0, 0.6, 1.2);
mistB.position.set(0, 0.2, 1.6);
mistC.position.set(0, 0.9, 2.0);

mistGroup.add(mistA); mistGroup.add(mistB); mistGroup.add(mistC);

// Chromatic "split" planes (very subtle)
var chromaGroup = new THREE.Group();
fxGroup.add(chromaGroup);

function makeChromaPlane(colorHex){
  var g = new THREE.PlaneGeometry(9, 9);
  var m = new THREE.MeshBasicMaterial({ color: colorHex, transparent: true, opacity: 0.0, depthWrite: false });
  var p = new THREE.Mesh(g, m);
  p.renderOrder = 11;
  return p;
}

var chromaR = makeChromaPlane(0xff4a4a);
var chromaB = makeChromaPlane(0x3c8dff);
chromaR.position.set(0.03, 0.55, 1.35);
chromaB.position.set(-0.03, 0.55, 1.35);
chromaGroup.add(chromaR); chromaGroup.add(chromaB);

// === SPEED LINES / STAR STREAKS for 3D space movement ===
var speedLinesGroup = new THREE.Group();
fxGroup.add(speedLinesGroup);

var speedLines = [];
var SPEED_LINE_COUNT = 60;

function createSpeedLine() {
  // Create a thin elongated line/streak
  var length = 0.8 + Math.random() * 1.5;
  var geo = new THREE.BoxGeometry(0.02, 0.02, length);
  var mat = new THREE.MeshBasicMaterial({
    color: 0xffffff,
    transparent: true,
    opacity: 0
  });
  var line = new THREE.Mesh(geo, mat);
  
  // Random position in a cylinder around the view axis
  var angle = Math.random() * Math.PI * 2;
  var radius = 1.5 + Math.random() * 4;
  line.userData.baseX = Math.cos(angle) * radius;
  line.userData.baseY = Math.sin(angle) * radius - 0.5;
  line.userData.speed = 0.5 + Math.random() * 1.0;
  line.userData.zOffset = Math.random() * 15;
  line.userData.length = length;
  
  line.position.set(line.userData.baseX, line.userData.baseY, -5 - line.userData.zOffset);
  
  return line;
}

for (var sli = 0; sli < SPEED_LINE_COUNT; sli++) {
  var sl = createSpeedLine();
  speedLines.push(sl);
  speedLinesGroup.add(sl);
}

fxGroup.visible = false;

  // Initial visibilities (Section 1)
  function setOpacity(obj, o){
    if (!obj) return;
    if (obj.material && obj.material.transparent){
      obj.material.opacity = o;
      obj.material.needsUpdate = true;
    }
  }

  // Section weights
  var w1=0,w2=0,w3=0,w4=0,w5=0;

  // Resize
  function resize(){
    var w = wrap.clientWidth || window.innerWidth;
    var h = wrap.clientHeight || window.innerHeight;
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    renderer.setSize(w, h, false);
    renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
  }
  window.addEventListener("resize", resize);

  // Animation loop
  
  // Eased transform state (prevents sudden motion)
  var camState = { x: 0, y: 1.15, z: 4.4 };
  var lookState = { x: 0, y: 0.2, z: 0 };
  var rotState = { igY: 0, rY: 0, rX: 0, sY: 0, sX: 0, ringZ: 0, aZ: 0, bZ: 0, cZ: 0 };
var raf = 0;
  var tiiv = 0;
  function animate(){
    raf = requestAnimationFrame(animate);





// =====================================================
// SMOOTH "WALKING THROUGH" TRANSITION SYSTEM
// - Feels like walking through a 3D exhibition
// - Very slow, continuous movement
// - ZERO overlapping - one object fully gone before next appears
// =====================================================

var panelCount = Math.max(1, panels.length || 10);
var maxPanelPos = panelCount - 1;

// === FASTER SCROLL SMOOTHING ===
// Higher values = quicker response
var inertia = 0.06; // Faster for quicker walk-through
scrollSmoothed = scrollSmoothed + (scrollTarget - scrollSmoothed) * inertia;

// Calculate panel position from scroll
var panelPosTarget = 0;
if (hero){
  var p = clamp(scrollSmoothed / scrollMax, 0, 1);
  panelPosTarget = p * maxPanelPos;
}

// Smooth panel position - faster
if (typeof window.__iglooPanelPos !== "number") window.__iglooPanelPos = 0;
var panelEase = 0.05; // Faster panel transitions
window.__iglooPanelPos = window.__iglooPanelPos + (panelPosTarget - window.__iglooPanelPos) * panelEase;

var panelPos = clamp(window.__iglooPanelPos, 0, maxPanelPos);
var panelI = Math.floor(panelPos);
var panelF = clamp(panelPos - panelI, 0, 1);

// Odd panels are transitions, even panels are main content
var isTransition = (panelI % 2) === 1;
var transitionProgress = isTransition ? panelF : 0.0;

// Which objects are we transitioning between?
var transFromBeat = isTransition ? Math.floor((panelI - 1) / 2) : 0;
var transToBeat = isTransition ? Math.min(4, transFromBeat + 1) : 0;

// Current beat when not in transition
var currentBeat = Math.floor(panelI / 2);
currentBeat = clamp(currentBeat, 0, 4);

// transW for subtle atmosphere effects
var transW = 0;
if (isTransition) {
  // Bell curve - peaks at middle of transition
  transW = Math.sin(transitionProgress * Math.PI);
  transW = transW * transW * 0.6; // Soften it
}

// Smooth story position - faster
var beatPosRaw = clamp(panelPos / 2, 0, 4);
if (typeof tiiv !== "number") tiiv = 0;
tiiv = tiiv + (beatPosRaw - tiiv) * 0.05;

// === OBJECT STATE FOR WALKING ANIMATION ===
if (!window.__iglooWalkState) {
  window.__iglooWalkState = {
    // Object opacities (0 = invisible, 1 = visible)
    o1: 1, o2: 0, o3: 0, o4: 0, o5: 0,
    // Object Z positions (0 = normal, positive = pushed back/far away)
    z1: 0, z2: 0, z3: 0, z4: 0, z5: 0,
    // Object Y positions (0 = normal, negative = moved down/far below)
    y1: 0, y2: 0, y3: 0, y4: 0, y5: 0,
    // Object scale (1 = normal, smaller = far away)
    s1: 1, s2: 0.3, s3: 0.3, s4: 0.3, s5: 0.3,
    // Camera walk position
    camWalk: 0,
    camY: 0,
    // Track last beat for clean transitions
    lastBeat: 0
  };
}
var walkState = window.__iglooWalkState;

// === CALCULATE TARGET STATES ===
// "Fading far away DOWN" effect: objects shrink, move back AND down
// Camera descends to next section
var o1T = 0, o2T = 0, o3T = 0, o4T = 0, o5T = 0;
var z1T = 8, z2T = 8, z3T = 8, z4T = 8, z5T = 8; // Default: far back
var y1T = -5, y2T = -5, y3T = -5, y4T = -5, y5T = -5; // Default: far below
var s1T = 0.15, s2T = 0.15, s3T = 0.15, s4T = 0.15, s5T = 0.15; // Default: tiny (far away)

function setTargets(beat, opacity, zPos, yPos, scale) {
  if (beat === 0) { o1T = opacity; z1T = zPos; y1T = yPos; s1T = scale; }
  else if (beat === 1) { o2T = opacity; z2T = zPos; y2T = yPos; s2T = scale; }
  else if (beat === 2) { o3T = opacity; z3T = zPos; y3T = yPos; s3T = scale; }
  else if (beat === 3) { o4T = opacity; z4T = zPos; y4T = yPos; s4T = scale; }
  else if (beat === 4) { o5T = opacity; z5T = zPos; y5T = yPos; s5T = scale; }
}

if (isTransition) {
  // === "FADING FAR AWAY DOWNWARD" ===
  // Current object recedes DOWN and INTO THE DISTANCE
  // Next object is ALREADY IN PLACE - no fade-in, just reveal
  
  var t = transitionProgress;
  
  if (t < 0.65) {
    // Phase 1: Current object recedes FAR AWAY DOWNWARD
    var fadeOut = t / 0.65; // 0 -> 1
    fadeOut = smoothstep(fadeOut);
    
    // Object shrinks as it goes far (scale: 1 -> 0.05)
    var departScale = lerp(1.0, 0.05, fadeOut);
    // Moves far back into distance (z: 0 -> 10)
    var departZ = lerp(0, 10, fadeOut);
    // Moves DOWN as it recedes (y: 0 -> -5) - NEGATIVE = DOWN
    var departY = lerp(0, -5, fadeOut);
    // Opacity fades due to distance
    var departOpacity = lerp(1.0, 0.0, fadeOut);
    
    setTargets(transFromBeat, departOpacity, departZ, departY, departScale);
    // Next object stays hidden until current is gone
    setTargets(transToBeat, 0, 0, 0, 1.0);
    
  } else {
    // Phase 2: Current object is GONE, next object is revealed IN PLACE
    // No animation on next object - it's already there
    var reveal = (t - 0.65) / 0.35; // 0 -> 1
    reveal = smoothstep(reveal);
    
    // Previous object completely gone (far below)
    setTargets(transFromBeat, 0, 12, -6, 0.01);
    
    // Next object is STATIC at normal position - only opacity reveals it
    // NO scale animation, NO position animation - it's just THERE
    setTargets(transToBeat, reveal, 0, 0, 1.0);
  }
  
} else {
  // === MAIN PANEL: Show current object fully in place ===
  setTargets(currentBeat, 1, 0, 0, 1.0);
}

// === FASTER INTERPOLATION ===
// Increased speeds for quicker transitions
var opacitySpeed = 0.06;   // Faster fade
var positionSpeed = 0.05;  // Faster movement
var scaleSpeed = 0.045;    // Faster scale

walkState.o1 += (o1T - walkState.o1) * opacitySpeed;
walkState.o2 += (o2T - walkState.o2) * opacitySpeed;
walkState.o3 += (o3T - walkState.o3) * opacitySpeed;
walkState.o4 += (o4T - walkState.o4) * opacitySpeed;
walkState.o5 += (o5T - walkState.o5) * opacitySpeed;

walkState.z1 += (z1T - walkState.z1) * positionSpeed;
walkState.z2 += (z2T - walkState.z2) * positionSpeed;
walkState.z3 += (z3T - walkState.z3) * positionSpeed;
walkState.z4 += (z4T - walkState.z4) * positionSpeed;
walkState.z5 += (z5T - walkState.z5) * positionSpeed;

// Y position interpolation (downward movement)
if (typeof walkState.y1 !== "number") walkState.y1 = 0;
if (typeof walkState.y2 !== "number") walkState.y2 = 0;
if (typeof walkState.y3 !== "number") walkState.y3 = 0;
if (typeof walkState.y4 !== "number") walkState.y4 = 0;
if (typeof walkState.y5 !== "number") walkState.y5 = 0;

walkState.y1 += (y1T - walkState.y1) * positionSpeed;
walkState.y2 += (y2T - walkState.y2) * positionSpeed;
walkState.y3 += (y3T - walkState.y3) * positionSpeed;
walkState.y4 += (y4T - walkState.y4) * positionSpeed;
walkState.y5 += (y5T - walkState.y5) * positionSpeed;

// Scale interpolation for "far away" effect
if (typeof walkState.s1 !== "number") walkState.s1 = 1;
if (typeof walkState.s2 !== "number") walkState.s2 = 0.2;
if (typeof walkState.s3 !== "number") walkState.s3 = 0.2;
if (typeof walkState.s4 !== "number") walkState.s4 = 0.2;
if (typeof walkState.s5 !== "number") walkState.s5 = 0.2;

walkState.s1 += (s1T - walkState.s1) * scaleSpeed;
walkState.s2 += (s2T - walkState.s2) * scaleSpeed;
walkState.s3 += (s3T - walkState.s3) * scaleSpeed;
walkState.s4 += (s4T - walkState.s4) * scaleSpeed;
walkState.s5 += (s5T - walkState.s5) * scaleSpeed;

// Camera descends during fade-away (going DOWN)
var fadeAwayProgress = isTransition ? clamp(transitionProgress / 0.65, 0, 1) : 0;
var camZTarget = isTransition ? 2.0 * Math.sin(fadeAwayProgress * Math.PI * 0.5) : 0;
var camYTarget = isTransition ? -1.8 * Math.sin(fadeAwayProgress * Math.PI * 0.5) : 0; // NEGATIVE = go DOWN
walkState.camWalk += (camZTarget - walkState.camWalk) * 0.05;
if (typeof walkState.camY !== "number") walkState.camY = 0;
walkState.camY += (camYTarget - walkState.camY) * 0.05;

// === SET VISIBILITY WEIGHTS ===
// Fade-away only: current object fades, next object just appears
w1 = clamp(walkState.o1, 0, 1);
w2 = clamp(walkState.o2, 0, 1);
w3 = clamp(walkState.o3, 0, 1);
w4 = clamp(walkState.o4, 0, 1);
w5 = clamp(walkState.o5, 0, 1);

// Scale-based visibility for fade-away effect only
// Objects that are small (fading away) get hidden
var scaleThreshold = 0.3;
if (walkState.s1 < scaleThreshold && walkState.s1 < 0.9) w1 *= (walkState.s1 / scaleThreshold);
if (walkState.s2 < scaleThreshold && walkState.s2 < 0.9) w2 *= (walkState.s2 / scaleThreshold);
if (walkState.s3 < scaleThreshold && walkState.s3 < 0.9) w3 *= (walkState.s3 / scaleThreshold);
if (walkState.s4 < scaleThreshold && walkState.s4 < 0.9) w4 *= (walkState.s4 / scaleThreshold);
if (walkState.s5 < scaleThreshold && walkState.s5 < 0.9) w5 *= (walkState.s5 / scaleThreshold);

// Strict: only show one object at a time
var maxW = Math.max(w1, w2, w3, w4, w5);
if (maxW > 0.01) {
  var threshold = maxW * 0.6; // Very strict - minimal overlap
  if (w1 < threshold) w1 = 0;
  if (w2 < threshold) w2 = 0;
  if (w3 < threshold) w3 = 0;
  if (w4 < threshold) w4 = 0;
  if (w5 < threshold) w5 = 0;
}

// finalW: slightly reduce during transitions for atmosphere
var finalW = 1.0 - (transW * 0.15);

// Apply finalW
w1 *= finalW;
w2 *= finalW;
w3 *= finalW;
w4 *= finalW;
w5 *= finalW;

// transT is used for transition FX animation timing
var transT = isTransition ? panelF : 0.0;

// Expose active panel step (1..10) to CSS/HUD
try {
  var step = Math.round(panelPos) + 1;
  hero.setAttribute('data-step', String(clamp(step, 1, panelCount)));
  hero.style.setProperty('--igloo-story-pos', String(tiiv));
  hero.style.setProperty('--igloo-panel-pos', String(panelPos));
  hero.style.setProperty('--igloo-trans-w', String(transW));
  hero.style.setProperty('--igloo-final-w', String(finalW));
  hero.style.setProperty('--igloo-trans-progress', String(transitionProgress));
} catch(e){}

    // Terrain + igloo visibility (1 and 5)
    var terrainO = clamp(w1 + w5, 0, 1);
    terrain.visible = terrainO > 0.01;
    terrain.material.opacity = 1.0; // opaque

    iglooGroup.visible = terrain.visible;
    // Igloo glow ramps in section 5
    var glow = clamp(w5, 0, 1);
    iglooShellMat.emissive.setHex(0xeaf4ff);
    iglooShellMat.emissiveIntensity = 0.35 * glow;
    seam1.material.opacity = lerp(0.06, 0.55, glow);
    seam2.material.opacity = lerp(0.05, 0.50, glow);
    seam3.material.opacity = lerp(0.04, 0.45, glow);

    // Slight ambient lift when crystal/rings are active
    light2.intensity = lerp(0.55, 0.70, clamp(w2+w3+w4,0,1));

    // Crystal raw (2)
    var rawO = clamp(w2, 0, 1);
    crystalRaw.visible = rawO > 0.01;
    setOpacity(crystalRaw, rawO);

    // Crystal slab + logo (3)
    var slabO = clamp(w3, 0, 1);
    crystalSlab.visible = slabO > 0.01;
    setOpacity(crystalSlab, slabO);

    logoPlane.visible = slabO > 0.01;
    logoPlaneMat.opacity = slabO * 0.85;

    // Rings (4)
    var ringO = clamp(w4, 0, 1);
    rings.visible = ringO > 0.01;
    ringA.material.opacity = ringO * 0.75;
    ringB.material.opacity = ringO * 0.55;
    ringC.material.opacity = ringO * 0.35;

    
// TRANSITION shards (odd panels): DISABLED - removed rock particles
// transitionGroup visibility is now permanently hidden
transitionGroup.visible = false;
/* SHARDS DISABLED - original code commented out:
for (var si=0; si<shards.length; si++){
  var sh = shards[si];
  var b = sh.userData.base;
  // explode outward then re-gather slightly
  var ttt = smoothstep(clamp(transT, 0, 1));
      var spread = 0.75 + 1.05 * ttt;
  var wob = Math.sin((performance.now()*0.001) * (0.6 + b.sp) + si*0.15) * 0.06;
  sh.position.set(b.x * spread, b.y * (0.9 + 0.2*smoothstep(transT)) + wob, b.z * spread);

  // rotate
  sh.rotation.x = b.rx + performance.now()*0.001 * (0.35 + b.sp*0.25);
  sh.rotation.y = b.ry + performance.now()*0.001 * (0.25 + b.sp*0.20);
  sh.rotation.z = b.rz + performance.now()*0.001 * (0.18 + b.sp*0.18);

  // opacity pulse
  var pulse = 0.65 + 0.35 * Math.sin((performance.now()*0.001) * 1.2 + si*0.07);
  var tw = smoothstep(clamp(transW, 0, 1));
      sh.material.opacity = clamp(tw * 0.45 * pulse, 0, 0.65);
}
*/


// === SUBTLE WALKING TRANSITION EFFECTS ===
// Very gentle effects that don't distract from the walking feel
var transIndex = isTransition ? Math.max(0, Math.min(4, transFromBeat)) : 0;

// FX Group disabled - no white mist or effects
fxGroup.visible = false;
speedLinesGroup.visible = false; // Speed lines disabled

// Face FX planes toward camera
mistGroup.quaternion.copy(camera.quaternion);
chromaGroup.quaternion.copy(camera.quaternion);

if (isTransition && transW > 0.05) {
  // Minimal fog increase during transition - NO WHITE MIST
  var fadeAwayPhase = transitionProgress < 0.65;
  var fogTarget = fadeAwayPhase ? 0.08 : 0.06;
  scene.fog.density = lerp(scene.fog.density, fogTarget, 0.04);
  
  // WHITE MIST DISABLED - all opacity set to 0
  mistA.material.opacity = 0;
  mistB.material.opacity = 0;
  mistC.material.opacity = 0;
  
  // No chromatic effect
  chromaR.material.opacity = 0;
  chromaB.material.opacity = 0;
  
  // Slight ambient dim during fade-away, brighten for reveal
  var lightTarget = fadeAwayPhase ? 0.45 : 0.55;
  light2.intensity = lerp(light2.intensity, lightTarget, 0.04);
  
} else {
  // Normal: clear fog
  scene.fog.density = lerp(scene.fog.density, 0.05, 0.04);
  
  // Keep mist disabled
  mistA.material.opacity = 0;
  mistB.material.opacity = 0;
  mistC.material.opacity = 0;
  chromaR.material.opacity = 0;
  chromaB.material.opacity = 0;
  
  light2.intensity = lerp(light2.intensity, 0.55, 0.04);
}

// === SPEED LINES DISABLED ===
// Speed lines removed as requested
for (var sli = 0; sli < speedLines.length; sli++) {
  var sl = speedLines[sli];
  sl.material.opacity = 0;
  sl.visible = false;
}

// Camera / motion per section
    var time = performance.now() * 0.001;

    
// === DESCENDING CAMERA MOVEMENT ===
// Camera moves DOWN during transitions

// Gentle ambient drift
var driftX = Math.sin(time * 0.08) * 0.04;
var driftY = Math.cos(time * 0.06) * 0.025;

// Base camera Z position
var camZBase = lerp(4.4, 3.2, ringO);

// Camera moves forward and DOWN during transitions
var camZTarget = camZBase - walkState.camWalk;
var camYOffset = walkState.camY; // Descend during transitions

var camXTarget = driftX;
var camYTarget = 1.15 + driftY + camYOffset;

// Faster camera movement
var camK = 0.045;
camState.x = camState.x + (camXTarget - camState.x) * camK;
camState.y = camState.y + (camYTarget - camState.y) * camK;
camState.z = camState.z + (camZTarget - camState.z) * camK;

camera.position.set(camState.x, camState.y, camState.z);

// Smooth look direction - look slightly DOWN during descent
var lxT = 0;
var lyT = 0.2 + camYOffset * 0.3;
var lzT = -walkState.camWalk * 0.2;
var lookK = 0.04;
lookState.x = lookState.x + (lxT - lookState.x) * lookK;
lookState.y = lookState.y + (lyT - lookState.y) * lookK;
lookState.z = lookState.z + (lzT - lookState.z) * lookK;

camera.lookAt(lookState.x, lookState.y, lookState.z);

    // Object motion - faster rotations
    var igTarget = Math.sin(time * 0.10) * 0.06;
    rotState.igY = rotState.igY + (igTarget - rotState.igY) * 0.12;
    iglooGroup.rotation.y = rotState.igY;

    // Crystals rotate
    var rYTarget = time * 0.18;
    rotState.rY = rotState.rY + (rYTarget - rotState.rY) * 0.14;
    crystalRaw.rotation.y = rotState.rY;
    var rXTarget = Math.sin(time * 0.14) * 0.10;
    rotState.rX = rotState.rX + (rXTarget - rotState.rX) * 0.14;
    crystalRaw.rotation.x = rotState.rX;

    var sYTarget = time * 0.14;
    rotState.sY = rotState.sY + (sYTarget - rotState.sY) * 0.14;
    crystalSlab.rotation.y = rotState.sY;
    var sXTarget = Math.sin(time * 0.12) * 0.08;
    rotState.sX = rotState.sX + (sXTarget - rotState.sX) * 0.14;
    crystalSlab.rotation.x = rotState.sX;

    // Rings spin
    var ringZTarget = time * 0.24;
    rotState.ringZ = rotState.ringZ + (ringZTarget - rotState.ringZ) * 0.15;
    rings.rotation.z = rotState.ringZ;
    var aZTarget = time * 0.18;
    rotState.aZ = rotState.aZ + (aZTarget - rotState.aZ) * 0.15;
    ringA.rotation.z = rotState.aZ;
    var bZTarget = -time * 0.14;
    rotState.bZ = rotState.bZ + (bZTarget - rotState.bZ) * 0.15;
    ringB.rotation.z = rotState.bZ;
    var cZTarget = time * 0.10;
    rotState.cZ = rotState.cZ + (cZTarget - rotState.cZ) * 0.15;
    ringC.rotation.z = rotState.cZ;

    // === DESCENDING 3D OBJECT POSITIONING ===
    // Objects move in Z-space, Y-space (DOWN), AND scale as they recede
    // "Far away down" effect: small scale + far Z + low Y = distant below
    
    // Get scale and Y values
    var sc1 = clamp(walkState.s1, 0.1, 1.2);
    var sc2 = clamp(walkState.s2, 0.1, 1.2);
    var sc3 = clamp(walkState.s3, 0.1, 1.2);
    var sc4 = clamp(walkState.s4, 0.1, 1.2);
    var sc5 = clamp(walkState.s5, 0.1, 1.2);
    
    var yOff1 = walkState.y1 || 0;
    var yOff2 = walkState.y2 || 0;
    var yOff3 = walkState.y3 || 0;
    var yOff4 = walkState.y4 || 0;
    var yOff5 = walkState.y5 || 0;
    
    // Object 1: Terrain + Igloo (beat 0 and 5)
    var envFade = clamp(w2+w3+w4, 0, 1);
    var envScale = (currentBeat === 0 || currentBeat === 4) ? lerp(sc1, sc5, w5 / Math.max(0.01, w1 + w5)) : Math.max(sc1, sc5);
    var envY = (currentBeat === 0 || currentBeat === 4) ? lerp(yOff1, yOff5, w5 / Math.max(0.01, w1 + w5)) : Math.min(yOff1, yOff5);
    
    terrain.position.y = lerp(-0.45, -0.95, envFade) + envY * 0.5;
    terrain.position.z = 0.2 + walkState.z1 * 0.5;
    terrain.scale.setScalar(envScale);
    
    iglooGroup.position.y = lerp(-0.15, -0.55, envFade) + envY * 0.5;
    iglooGroup.position.z = walkState.z1 * 0.5;
    iglooGroup.scale.setScalar(envScale);
    
    // Object 2: Crystal Raw - recedes DOWN and back
    crystalRaw.position.y = 0.05 + yOff2 * 0.4;
    crystalRaw.position.z = walkState.z2 * 0.5;
    crystalRaw.scale.set(sc2, sc2 * 1.1, sc2);
    
    // Object 3: Crystal Slab + Logo - recedes DOWN and back
    crystalSlab.position.y = 0.06 + yOff3 * 0.4;
    crystalSlab.position.z = walkState.z3 * 0.5;
    crystalSlab.scale.set(sc3 * 1.05, sc3 * 0.78, sc3 * 0.85);
    logoPlane.position.y = 0.05 + yOff3 * 0.4;
    logoPlane.position.z = walkState.z3 * 0.5 + 0.05;
    logoPlane.scale.setScalar(sc3);
    
    // Object 4: Rings - recedes DOWN and back
    rings.position.y = yOff4 * 0.4;
    rings.position.z = walkState.z4 * 0.5;
    rings.scale.setScalar(sc4);

    // Render
    renderer.render(scene, camera);
  }

  computeScrollState();
  resize();
  animate();

  // Cleanup on theme editor unload
  document.addEventListener('shopify:section:unload', function(){
    try { cancelAnimationFrame(raf); } catch(e){}
    try { window.removeEventListener('resize', resize); } catch(e){}
    try { hero && hero.removeEventListener('scroll', computeScrollState); } catch(e){}
    try { renderer.dispose(); } catch(e){}
    try { wrap.innerHTML = ""; } catch(e){}
    try { delete wrap.__iglooRenderer; } catch(e){}
  }, { once:true });
}

  function boot() {
    initSnow();
    initDome();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
